export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сақтау"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Егер сіз мұны көріп тұрсаңыз, форма алынбаған (бірақ сіз мұны көрмеуіңіз керек)"])}
}